import React from 'react';
import { ColorRing } from 'react-loader-spinner';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { remCss } from 'src/helpers';
import { colors, fileAreaStyle, fileAreaWebExtra, centerOverlayStyle } from './styles';
import { View } from 'components/basic';

const ICON_BY_EXTENSION = {
  pdf: BASE_ICONS.FILE_PDF3,
  xls: BASE_ICONS.FILE_XLS,
  xlsx: BASE_ICONS.FILE_XLS,
  doc: BASE_ICONS.FILE_DOC,
  docx: BASE_ICONS.FILE_DOC
};

// Renders any other file type (pdf, doc, xls, ...) as an icon or thumbnail,
// clickable to trigger a download. Shows a spinner overlay while downloading.
function GenericFilePreview({ file, type, width, thumbnail, downloading, onClick, expired }) {
  const iconWidth = width >= 140 ? width * 0.6 : 50;
  const previewThumbnail = file?.thumbnail || thumbnail;

  return (
    <View onClick={onClick} style={{ ...fileAreaStyle, ...fileAreaWebExtra, position: 'relative' }}>
      {!previewThumbnail || expired ? (
        <SVGIcon
          iconname={expired ? BASE_ICONS.FILE_X : ICON_BY_EXTENSION[type] || BASE_ICONS.FILE}
          width={iconWidth}
          padding={width > 140 ? 2 : 0}
          fill={colors.primary}
        />
      ) : (
        // web-only: <img> has no direct RN equivalent, use <Image> when porting
        <img alt='' src={previewThumbnail} title={file?.name || file?.originalName} />
      )}

      {downloading && (
        <View style={centerOverlayStyle(30)}>
          <ColorRing
            colors={[
              colors.primary,
              colors.primary,
              colors.primary,
              colors.primary,
              colors.primary
            ]}
            height={remCss(30)}
            width={remCss(30)}
            strokeWidth={3}
          />
        </View>
      )}
    </View>
  );
}

export default GenericFilePreview;
